import FormUtente from "./FormUtente";
import {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {useDispatch} from "react-redux";
import {setSearch} from "../../../actions/IndexActions";
import Utils from "../../../utils/Utils";
import ApmsService from "../../../services/ApmsService";
import Enums from "../../../utils/Enums.json"

function ModificaUtente(props) {

    const history = useHistory()
    const [state, setState] = useState({...props.state})
    const [showSpinner, setShowSpinner] = useState(false)
    const dispatch = useDispatch()
    const [disabledButtonSalvaModifica, setDisabledButtonSalvaModifica] = useState(false)
    const [suggestionsSportelli,setSuggestionsSportelli] = useState([])
    const [gruppiPerApplicazione,setGruppiPerApplicazione] = useState([])
    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    useEffect(() => {
        setState(props.state)
        disabledSalvaModifica(props.state)
    }, [props])

    useEffect(()=>{
        Utils.recuperoGruppiPerApplicazione(setShowSpinner,setSuggestionsSportelli,setGruppiPerApplicazione,sessioneUtente)
    },[])

    function modificaUtente() {
        setShowSpinner(true)
        let utente = Utils.createJsonUtente(state,suggestionsSportelli,JSON.parse(sessionStorage.getItem("comuniPerCodice")))
        if (state.ruolo === history.location.vecchioRuolo) {
            ApmsService.modificaUtente(utente).then(res => {
                if (res.status === 200) {
                    props.getUtenti()
                } else {
                    history.push({
                        pathname: "/errore"
                    })
                }
                setState({
                    cognome: "",
                    nome: "",
                    ente: "",
                    codiceFiscale: "",
                    telefono: "",
                    mail: "",
                    ruolo: "",
                    ultimoLogin: ""
                })
                setShowSpinner(false)
                dispatch(setSearch(false))
                window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione,"Operazione avvenuta con successo");
            }).catch(reason => {
                window.alert(Enums.TOASTERTYPE.ERROR.descrizione,"Errore durante l'esecuzione dell'operazione");
                console.log("Errore Operation POST Utente: " + reason)
                setShowSpinner(false)
            })
        } else {
            let jsonEliminaUtente = {
                applicazione: "RAF",
                codiceFiscale: state.codiceFiscale,
                struttura: "spid",
                listaGruppi: [{codicegruppo: history.location.vecchioRuolo}]
            }
            ApmsService.eliminaUtente(jsonEliminaUtente).then(res => {
                if (res.status === 200) {
                    ApmsService.inserisciUtente(utente).then(res => {
                        if (res.status === 200) {
                            props.getUtenti()
                        } else {
                            history.push({
                                pathname: "/errore"
                            })
                        }
                        setState({
                            cognome: "",
                            nome: "",
                            ente: "",
                            codiceFiscale: "",
                            telefono: "",
                            mail: "",
                            ruolo: "",
                            ultimoLogin: ""
                        })
                        window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione,"Operazione avvenuta con successo");
                        setShowSpinner(false)
                    }).catch(reason => {
                        window.alert(Enums.TOASTERTYPE.ERROR.descrizione,"Errore durante l'esecuzione dell'operazione");
                        console.log("Errore Operation POST Utente: " + reason)
                        setShowSpinner(false)
                    })
                }
            }).catch(reason => {
                window.alert(Enums.TOASTERTYPE.ERROR.descrizione,"Errore durante l'esecuzione dell'operazione");
                console.log("Errore Operation DELETE Utente: " + reason)
                setShowSpinner(false)
            })
        }
    }

    function eliminaUtente(){
        let jsonEliminaUtente = {
            applicazione: "RAF",
            codiceFiscale: state.codiceFiscale,
            struttura: "spid",
            listaGruppi: [{codicegruppo: state.ruolo}]
        }
        ApmsService.eliminaUtente(jsonEliminaUtente).then(res => {
            if (res.status === 200) {
                props.getUtenti()
            } else {
                history.push({
                    pathname: "/errore"
                })
            }
            setState({
                cognome: "",
                nome: "",
                ente: "",
                codiceFiscale: "",
                telefono: "",
                mail: "",
                ruolo: "",
                ultimoLogin: ""
            })
            dispatch(setSearch(false))
            window.alert(Enums.TOASTERTYPE.SUCCESS.descrizione,"Operazione avvenuta con successo");
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation DELETE Utente: " + reason)
            setShowSpinner(false)
        })
    }

    function onChange(id, value) {
        let newState = {...state}
        if (id.startsWith("ente")) {
            let selectedOptions = []
            for (let i = 0; i < value.currentTarget.selectedOptions.length; i++) {
                selectedOptions.splice(i, 1, value.currentTarget.selectedOptions[i].value)
            }
            newState["ente"] = selectedOptions
        } else {
            let newId = id.replace(/[0-9]/g, '').replace("Modifica", "");
            newState[newId] = value
        }
        setState(newState)
        disabledSalvaModifica(newState)
    }

    function disabledSalvaModifica(newState) {
        if (!newState || !newState.cognome || !newState.nome || !newState.ente ||
            !newState.codiceFiscale || !newState.telefono || !newState.mail || !newState.ruolo  || (newState.codiceFiscale && !Utils.isCFValid(newState.codiceFiscale.replace("TINIT-","")))) {
            return setDisabledButtonSalvaModifica(true)
        } else {
            return setDisabledButtonSalvaModifica(false)
        }
    }

    function annullaCreazioneUtente() {
        setState({
            cognome: "",
            nome: "",
            ente: "",
            codiceFiscale: "",
            telefono: "",
            email: "",
            ruolo: "",
            ultimoLogin: ""
        })
    }

    return (<FormUtente modifica={true}
                        state={state}
                        showSpinner={showSpinner}
                        onChange={onChange}
                        onClickAnnulla={annullaCreazioneUtente}
                        onClickSalvaModifica={modificaUtente}
                        onClickElimina={eliminaUtente}
                        disabledButtonSalvaModifica={disabledButtonSalvaModifica}
                        suggestionsSportelli={suggestionsSportelli}
                        gruppiPerApplicazione={gruppiPerApplicazione}
    />)
}

export default ModificaUtente
